<template>
    <div class="w-12 h-12 group relative">
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 40 40" class="group-hover:opacity-0 absolute top-0 transition-opacity duration-150">
            <defs>
                <clipPath id="clippath">
                    <rect class="cls-1" x=".35" y=".34" width="39.31" height="39.32"/>
                </clipPath>
            </defs>
            <g class="cls-4">
                <g>
                    <path class="cls-2" d="M20.01.84c10.58,0,19.16,8.58,19.16,19.16s-8.58,19.17-19.16,19.17c-10.58-.01-19.16-8.59-19.16-19.16S9.43.84,20.01.84Z"/>
                    <path class="cls-3" d="M24.22,30.09h-8.75c-2.69,0-4.88-2.19-4.88-4.88v-8.75c0-2.69,2.19-4.88,4.88-4.88h8.75c2.69,0,4.88,2.19,4.88,4.88v8.75c0,2.69-2.19,4.88-4.88,4.88ZM15.47,12.59c-2.14,0-3.88,1.74-3.88,3.88v8.75c0,2.14,1.74,3.88,3.88,3.88h8.75c2.14,0,3.88-1.74,3.88-3.88v-8.75c0-2.14-1.74-3.88-3.88-3.88h-8.75ZM19.89,24.8c-.21,0-.43-.02-.64-.05-.83-.13-1.59-.52-2.19-1.12-.6-.6-.99-1.36-1.12-2.19-.13-.84,0-1.68.38-2.43.38-.76.98-1.36,1.73-1.75.75-.39,1.59-.53,2.43-.41.84.12,1.64.52,2.24,1.13.6.6,1,1.4,1.13,2.24.12.84-.02,1.68-.41,2.43-.39.75-1,1.35-1.75,1.73-.56.28-1.17.43-1.79.43h-.01ZM19.88,17.8c-.48,0-.95.11-1.38.34-.56.29-1.01.75-1.3,1.31-.29.57-.38,1.2-.28,1.83.1.63.39,1.2.84,1.64.45.45,1.02.74,1.64.84.63.1,1.26,0,1.83-.28.57-.29,1.02-.74,1.31-1.3.29-.56.4-1.19.31-1.82-.09-.63-.39-1.23-.85-1.68-.45-.45-1.05-.75-1.68-.85-.15-.02-.3-.03-.45-.03h.01Z"/>
                    <path class="cls-3" d="M24.67,16.78c-.41,0-.75-.34-.75-.75s.33-.75.75-.75.75.34.75.75-.34.75-.75.75Z"/>
                </g>
            </g>
        </svg>
        <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 40 40" class="opacity-0 group-hover:opacity-100 absolute top-0 transition-opacity duration-150">
            <defs>
                <clipPath id="clippath">
                    <rect class="layer-2-cls-1" x=".35" y=".34" width="39.31" height="39.32"/>
                </clipPath>
            </defs>
            <g class="layer-2-cls-4">
                <g>
                    <path class="layer-2-cls-2" d="M20.01.84c10.58,0,19.16,8.58,19.16,19.16s-8.58,19.17-19.16,19.17c-10.58-.01-19.16-8.59-19.16-19.16S9.43.84,20.01.84Z"/>
                    <path class="layer-2-cls-3" d="M22,18.68c-.46-.46-1.04-.75-1.68-.85-.15-.02-.3-.03-.44-.03-.48,0-.95.11-1.38.34-.56.29-1.01.75-1.3,1.31-.29.57-.38,1.2-.28,1.83.1.63.39,1.2.84,1.64.45.44,1.02.74,1.65.84.63.1,1.26,0,1.83-.28.57-.29,1.02-.74,1.31-1.3.29-.56.4-1.19.31-1.82-.09-.63-.39-1.23-.85-1.68h-.01Z"/>
                    <path class="layer-2-cls-3" d="M24.22,11.59h-8.75c-2.69,0-4.88,2.19-4.88,4.88v8.75c0,2.69,2.19,4.88,4.88,4.88h8.75c2.69,0,4.88-2.19,4.88-4.88v-8.75c0-2.69-2.19-4.88-4.88-4.88ZM23.43,22.64c-.39.75-1,1.35-1.75,1.73-.56.28-1.17.43-1.79.43-.21,0-.43-.02-.64-.05-.84-.13-1.59-.52-2.19-1.12s-.99-1.36-1.12-2.19c-.13-.84,0-1.68.38-2.43.38-.76.98-1.36,1.73-1.75.75-.39,1.59-.53,2.43-.41.85.13,1.63.52,2.24,1.13.6.6,1,1.4,1.13,2.24.12.84-.02,1.68-.41,2.43h-.01ZM24.67,16.78c-.41,0-.75-.34-.75-.75s.33-.75.75-.75.75.34.75.75-.34.75-.75.75Z"/>
                </g>
            </g>
        </svg>
    </div>
</template>

<style scoped>
.cls-1, .cls-2 {
    fill: none;
}

.cls-3 {
    fill: #242653;
}

.cls-2 {
    stroke: #242653;
}

.cls-4 {
    clip-path: url(#clippath);
}

.layer-2-cls-1, .layer-2-cls-2 {
    fill: none;
}

.layer-2-cls-3 {
    fill: #242653;
}

.layer-2-cls-2 {
    stroke: #242653;
}

.layer-2-cls-4 {
    clip-path: url(#clippath);
}
</style>